var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonGyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.653,
    height: 27.655,
    viewBox: "0 0 27.653 27.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "person-gy-icon",
    d: "M32.14,31.456c-.519-2.29-3.478-3.406-4.5-3.767a33.559,33.559,0,0,0-3.752-.72,3.812,3.812,0,0,1-1.736-.8c-.288-.346-.115-3.55-.115-3.55a10.682,10.682,0,0,0,.821-1.563,20.158,20.158,0,0,0,.6-2.729s.591,0,.8-1.037a10.2,10.2,0,0,0,.533-2.413c-.043-.828-.5-.807-.5-.807a12.627,12.627,0,0,0,.49-3.695c.065-2.96-2.254-5.877-6.453-5.877-4.256,0-6.525,2.917-6.46,5.877a13.171,13.171,0,0,0,.483,3.695s-.454-.022-.5.807a10.2,10.2,0,0,0,.533,2.413c.2,1.037.8,1.037.8,1.037a20.158,20.158,0,0,0,.6,2.729,10.682,10.682,0,0,0,.821,1.563s.173,3.2-.115,3.55a3.812,3.812,0,0,1-1.736.8,33.559,33.559,0,0,0-3.752.72c-1.023.36-3.983,1.476-4.5,3.767a.576.576,0,0,0,.569.7h26.5A.575.575,0,0,0,32.14,31.456Z",
    transform: "translate(-4.501 -4.5)",
    fill: "#6d6d6d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonGyIcon);
export default __webpack_public_path__ + "static/media/person-gy-icon.52293c8de57c9fc760203e1611ae34e1.svg";
export { ForwardRef as ReactComponent };